import { Badge } from "@/components/ui/badge";
import { calculateWeightedValue } from "@/services/salesProjectionService";

interface WeightedValueDisplayProps {
  amount: number | null;
  probability: number | null;
  currency?: string;
  showProbability?: boolean;
  className?: string;
}

export function WeightedValueDisplay({ 
  amount, 
  probability, 
  currency = "EUR", 
  showProbability = true,
  className 
}: WeightedValueDisplayProps) {
  const weightedAmount = calculateWeightedValue(amount, probability);
  
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('el-GR', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  if (!amount || !probability) {
    return <span className={className}>-</span>;
  }

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="font-medium">
        {formatCurrency(weightedAmount)}
      </div>
      {showProbability && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span>{formatCurrency(amount)}</span>
          <Badge variant="outline" className="text-xs">
            {probability}%
          </Badge>
        </div>
      )}
    </div>
  );
}